import { useTranslation } from '@nextgen-web-framework/all';
import { useCallback } from 'react';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { CartNotificationTheme } from '../components';
import { TOAST_TIMEOUT } from '../types/enums';
import { useCartNotification } from './useCartNotification';

export type ExpectionType = {
  theme?: CartNotificationTheme;
  content?: string;
  subtext?: string;
  icon?: IconName;
};

export const useExceptionToast = ({
  theme = CartNotificationTheme.RED,
  content,
  subtext,
  icon = 'exclamation-square',
}: ExpectionType = {}) => {
  const t = useTranslation();
  const { createToast, deleteToast } = useCartNotification('addToCartButton');
  const exceptionOccuredText = t('cart.addToCartButton.exceptionOccured');
  const triggerToast = useCallback(() => {
    createToast(
      {
        theme: theme,
        rightSeperator: false,
        content: content ?? exceptionOccuredText,
        subtext: subtext,
        clickIcon: 'times',
        icon: icon,
        timeOut: TOAST_TIMEOUT,
      },
      deleteToast,
    );
  }, []);
  return triggerToast;
};
